/**
 * Adapted from JFE:
 * https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/platform/utils/feature-flagging-using-meta/src/utils/get-all-feature-flags/index.tsx
 */

import memoizeOne from '@atlassian/help-center-common-util/memoize-one';
import { getFeatureFlagsFromMeta } from '../utils';

export default memoizeOne(getFeatureFlagsFromMeta);
